<template>
  <div>
    <Swiper class="swiper" :options="swiperOption">
      <swiper-slide :class="{ 'current': category.id === clickId }" v-for="category in clientCategory" :key="category.id" class="swiper_category">
        <button
          class="category_btn category_btn_active"
          @click="clickCategory(category.id)"
        >
          {{ category.title }} ({{category.channels.length}})
        </button>
      </swiper-slide>
    </Swiper>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.min.css'

export default {
  name: 'CourseListCategory',
  props: {
    clientCategory: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      clickId: 0,
      swiperOption: {
        slidesPerView: 'auto'
      }
    }
  },
  methods: {
    clickCategory (id) {
      this.clickId = id
      this.$emit('category-id', id)
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/clients.scss";

.swiper-container {
  width: 100%;
  margin-bottom: 20px;
}

.swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
  >>> .slide_img {
    border-radius: 10px;
  }
}

.swiper_category {
  width: auto;
  margin-right: 30px;
}

.category_btn {
  background-color: transparent;
  border: transparent;
  font-size: 16px;
  padding: 7px 13px;
  border-radius: 5px;
  outline:none;
  // &:hover {
  //   background-color: #176e8d;
  //   color: white;
  // }
}

@media screen and (min-width: 768px) {
  .category_btn:hover {
    background-color: #176e8d;
    color: white;
  }
}

.current {
  .category_btn {
    &:hover,&.category_btn_active {
      color: #176e8d;
      border: 1px solid #176e8d;
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/clients/ClientsCourseList/components/CourseListCategory.vue